import { render } from "./IdentifyDblSelect.vue?vue&type=template&id=86d8ca26&scoped=true"
import script from "./IdentifyDblSelect.vue?vue&type=script&lang=js"
export * from "./IdentifyDblSelect.vue?vue&type=script&lang=js"

import "./IdentifyDblSelect.vue?vue&type=style&index=0&id=86d8ca26&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86d8ca26"]])

export default __exports__